import Footer from "../../pages/Footerpage";
import Header from "../../pages/Header";
import { Outlet, useLocation } from "react-router-dom";

const PublicLayout = () => {
  const location = useLocation();
  const hideHeaderFooter = ["/login", "/register", "/ForgotPassword" ,"/gpaypage"].includes(location.pathname);

  return (
    <>
      <Header />
      <Outlet />
      {!hideHeaderFooter && <Footer />}
    </>
  );
};

export default PublicLayout;